import Shell from './shell.js';
import DirectClientMessageBus from '../message-bus/direct-client.js';
import authenticationPlugin from '../plugin/auth/index.js';
import environmentPlugin from '../plugin/environment/index.js';
import navigationPlugin from '../plugin/navigation/index.js';
import routingPlugin from '../plugin/routing/index.js';
import { i18n as i18nPlugin } from '../plugin/i18n/index.js';
import { UXPlugin } from '../plugin/ux/index.js';
import { TrackingPlugin, } from '../plugin/tracking/tracking.js';
import loggerPlugin from '../plugin/logger/index.js';
import { LocationPlugin } from '../plugin/location/index.js';
function isStagingEnvironment() {
    return /\.dev$/.test(window.location.hostname);
}
export function initShell(environment) {
    const shell = new Shell();
    if (isStagingEnvironment()) {
        Object.entries(environment.getApplications()).forEach(([appName, appConfig]) => {
            var _a;
            const url = new URL(appConfig.publicURL);
            url.pathname = ((_a = appConfig.container) === null || _a === void 0 ? void 0 : _a.enabled)
                ? '/container'
                : `/${appName}`;
            appConfig.publicURL = `${window.location.origin}${url.pathname}/${url.hash}`;
        });
    }
    shell.setMessageBus(new DirectClientMessageBus());
    shell.getPluginManager().registerPlugin('auth', authenticationPlugin());
    shell.getPluginManager().registerPlugin('routing', routingPlugin());
    shell
        .getPluginManager()
        .registerPlugin('environment', environmentPlugin(environment));
    shell
        .getPluginManager()
        .registerPlugin('i18n', i18nPlugin(shell, environment));
    const uxPlugin = new UXPlugin(shell);
    shell
        .getPluginManager()
        .registerPlugin('ux', uxPlugin);
    shell
        .getPluginManager()
        .registerPlugin('navigation', navigationPlugin(environment));
    const trackingPlugin = new TrackingPlugin();
    trackingPlugin.configureTracking(environment.getRegion(), environment.getUser(), environment.getUserLocale());
    shell
        .getPluginManager()
        .registerPlugin('tracking', trackingPlugin);
    shell.getPluginManager().registerPlugin('logger', loggerPlugin());
    shell
        .getPluginManager()
        .registerPlugin('location', new LocationPlugin());
    return shell;
}
export default { initShell };
//# sourceMappingURL=index.js.map